import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import clsx from 'clsx'
import Image from '@v4/components/common/Image'
import SortHandler from '@v4/components/common/SortHandler'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useCta5 } from './Cta5.hooks'
import Content from '../../components/Content'

const Cta5 = props => {
	const [
		{
			classes,
			mobileAlignment,
			mobileButtonWidth,
			withImage,
			image,
			withBgImage,
			isMobile,
			direction,

			text,
			textKey,
			textConfig,
			textEditable,

			additionalPosition,
			additionalText,
			additionalTextKey,
			additionalTextConfig,
			additionalTextEditable,

			buttonText,
			buttonTextKey,
			buttonTextConfig,
			buttonLink,
			buttonAction,
			buttonTextEditable,
		},
		{
			handleImageClick,
			handleTextClick,
			handleButtonClick,
			handleAdditionalClick,
			handleAdditionalTextChange,
			handleTextChange,
			handleButtonTextChange,
		},
	] = useCta5(props)

	return (
		<>
			{withBgImage && <Image className={clsx(classes.bgImage, 'cta5-bg-image')} metaData={image} isBackground />}
			<Grid className={classes.grid} container direction="column" alignItems="center">
				<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
					<Content
						mobileAlignment={mobileAlignment}
						mobileButtonWidth={mobileButtonWidth}
						text={text}
						textConfig={textConfig}
						buttonText={buttonText}
						buttonTextConfig={buttonTextConfig}
						buttonTextEditable={buttonTextEditable}
						onButtonTextChange={handleButtonTextChange}
						buttonLink={buttonLink}
						buttonAction={buttonAction}
						additionalText={additionalText}
						additionalPosition={additionalPosition}
						className={clsx(classes.content, 'cta5-container')}
						classes={{ button: classes.button }}
						onTextClick={handleTextClick}
						onButtonClick={handleButtonClick}
						onAdditionalClick={handleAdditionalClick}
						textEditable={textEditable}
						additionalTextEditable={additionalTextEditable}
						additionalTextConfig={additionalTextConfig}
						onTextChange={handleTextChange}
						onAdditionalTextChange={handleAdditionalTextChange}
						textKey={textKey}
						additionalTextKey={additionalTextKey}
						buttonTextKey={buttonTextKey}
						white={withBgImage}
					/>
					{withImage && (
						<div className={clsx(classes.imageWrap, 'cta5-image')}>
							<Image onClick={handleImageClick} className={classes.image} metaData={image} />
						</div>
					)}
				</SortHandler>
			</Grid>
		</>
	)
}

Cta5.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		additionalText: PropTypes.instanceOf(PageMetaData),
		image: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Cta5)
